@let currentRow = row();
@let realisation = currentRow.realisation;

@if (realisation.performer_id) {
    <span matTooltip="Verplaatst naar {{ currentRow.performerName ?? 'andere uitvoerder' }}">
        <button class="icon-button fs-5" mat-icon-button disabled>
            <i class="fa-solid fa-share"></i>
        </button>
    </span>
} @else if (realisation | isWorktime) {
    @if (!hasTooManyRegisteredMinutes) {
        <button
            class="icon-button fs-5"
            [class.valid]="realisation.submitted"
            [class.warning]="realisation.user_id && !realisation.submitted"
            mat-icon-button
            disabled>
            @if (!realisation.planning_has_entity_id && !realisation.user_planning_id) {
                <i class="fa-light fa-user-plus" matTooltip="Toegevoegd buiten planning"></i>
            } @else if (realisation.user_id && realisation.submitted) {
                <i class="fa-light fa-user-check" matTooltip="Volgens planning en ingediend"></i>
            } @else if (realisation.user_id && !realisation.submitted) {
                <i class="fa-light fa-user-clock" matTooltip="Volgens planning maar niet ingediend"></i>
            } @else {
                <i class="valid fa-light fa-circle-check fw-medium" matTooltip="Op basis van planning"></i>
            }
        </button>
    } @else {
        <button class="icon-button invalid fs-5" mat-icon-button disabled>
            <mat-icon
                class="warning fw-medium"
                fontSet="fa-regular"
                fontIcon="fa-circle-exclamation"
                matTooltip="Meer dan 12 uur geregistreerd op {{ realisation.bookdate | date: 'EEEE d MMM yyyy' }}">
            </mat-icon>
        </button>
    }
} @else if (realisation | isTraveltime) {
    <button class="icon-button fs-5" mat-icon-button disabled>
        <mat-icon fontSet="fa-light" fontIcon="fa-car-building"></mat-icon>
    </button>
}

@if (RealisationService.hourtypeIconNames.has(realisation.hourtype)) {
    <button class="icon-button fs-5" mat-icon-button disabled matTooltip="{{ realisation.hourtype | hourtype }}">
        <i class="fa-solid hourtype {{ RealisationService.hourtypeIconNames.get(realisation.hourtype) }}"></i>
    </button>
}

@if (isPauseEditable) {
    <div
        class="counts pause ms-2 px-1 text-center curpoint"
        [class.adjusted]="realisation.pause_adjusted"
        [class.changed]="currentRow.pauseChanged"
        [class.fw-bold]="realisation.pause_adjusted"
        [class.pe-none]="notEditable()"
        (click)="changePause($event, realisation.user_id)"
        matRipple>
        <i
            class="fa-mug-saucer me-0"
            [class.far]="!realisation.pause_adjusted"
            [class.fas]="realisation.pause_adjusted">
        </i>
        <br />
        {{ currentRow.pause | minutes }}
    </div>
}
